(function (upp, $UPP) {

    var USERS_REST_SERVICE = $UPP.URL_UPPLICATION_REST_SERVICE + 'users';

    AccountManagerService.$inject = [ '$q', 'appi', 'contextHolderManager' ];
    function AccountManagerService($q, appi, contextHolderManager) {
        var onRegisterSource$ = new Rx.Subject();
        var onUpdateSource$ = new Rx.Subject();
        var onRemoveSource$ = new Rx.Subject();

        Object.defineProperties(this, {
            /**
             * @private
             * @property {ng.IQService} AccountManagerService#$q
             */
            $q: { value: $q },
            /**
             * @private
             * @property {AppiService} AccountManagerService#appi
             */
            appi: { value: appi },
            /**
             * @private
             * @property {ContextHolderManager} AccountManagerService#contextHolderManager
             */
            contextHolderManager: { value: contextHolderManager },
            /**
             * @private
             * @property {Rx.Subject<void>} Rx.Subject#contextHolderManager
             */
            onRegisterSource$: { value: onRegisterSource$ },
            onUpdateSource$: { value: onUpdateSource$ },
            onRemoveSource$: { value: onRemoveSource$ },
            onRegister$: { value: onRegisterSource$.asObservable(), enumerable: true },
            onUpdate$: { value: onUpdateSource$.asObservable(), enumerable: true },
            onRemove$: { value: onRemoveSource$.asObservable(), enumerable: true },
        });
    }

    AccountManagerService.prototype.register = function(email, password, name, surname, fields) {
        if (!email)
            return this.$q.reject('email is required for register');
        if (!password)
            return this.$q.reject('password is required for register');
        if (!name)
            return this.$q.reject('name is required for register');
        if (!surname)
            return this.$q.reject('surname is required for register');

        return this.appi.http.post(USERS_REST_SERVICE + '/register', {
            email: email,
            password: password,
            name: name,
            surname: surname,
            fields: fields
        })
        .then(function(res) {
            this.onRegisterSource$.next(res);
            return res;
        }.bind(this))
        .catch(function(error) {
            this.onRegisterSource$.error(error);
            throw error;
        }.bind(this));
    }

    AccountManagerService.prototype.activate = function(email, code) {
        if (!email)
            return this.$q.reject('email is required for activate');
        if (!code)
            return this.$q.reject('code is required for activate');

        return this.appi.http.post(USERS_REST_SERVICE + '/activate', {
                email: email,
                code: code,
            })
            .then(function(res) {
                return res.data.token;
            })
            .catch(function(error) {
                throw error;
            });
    }

    AccountManagerService.prototype.resendActivation = function(email) {
        if (!email)
            return this.$q.reject('email is required for resend activation');

        return this.appi.http.post(USERS_REST_SERVICE + '/resend-activation', {
            email: email,
        })
            .then(function(res) {
                return res;
            }.bind(this))
            .catch(function(error) {
                throw error;
            }.bind(this));
    }

    AccountManagerService.prototype.update = function (password, name, surname, fields) {
        return this.appi.http.postSecure(USERS_REST_SERVICE + '/account', {
            password: password,
            name: name,
            surname: surname,
            fields: fields,
        })
        .then(function(res) {
            // Update the token so future calls are still authorized
            if (res.data && res.data.token)
                this.contextHolderManager._setToken(res.data.token);
            this.onUpdateSource$.next(res);
            return res;
        }.bind(this))
        .catch(function(error) {
            this.onUpdateSource$.error(error);
            throw error;
        }.bind(this));
    }

    AccountManagerService.prototype.remove = function () {
        return this.appi.http.deleteSecure(USERS_REST_SERVICE + '/user')
        .then(function(res) {
            this.onRemoveSource$.next(res);
            return res;
        }.bind(this))
        .catch(function(error) {
            this.onRemoveSource$.error(error);
            throw error;
        }.bind(this));
    }

    AccountManagerService.prototype.retrieve = function () {
        return this.appi.http.getSecure(USERS_REST_SERVICE);
    }

    upp.service('accountManagerService', AccountManagerService);
})(upp, $UPP)



// WEBPACK FOOTER //
// ./src/app/plugins/login/services/account-manager.service.js